import React from 'react';
/* eslint-disable */
export function Search(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="15" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.8438 15.1562L11.4062 10.75C12.4062 9.59375 13 8.125 13 6.5C13 2.9375 10.0625 0 6.5 0C2.90625 0 0 2.9375 0 6.5C0 10.0938 2.90625 13 6.5 13C8.09375 13 9.5625 12.4375 10.7188 11.4375L15.125 15.875C15.2188 15.9688 15.3438 16 15.5 16C15.625 16 15.75 15.9688 15.8438 15.875C16.0312 15.6875 16.0312 15.3438 15.8438 15.1562ZM6.5 12C3.4375 12 1 9.5625 1 6.5C1 3.46875 3.4375 1 6.5 1C9.53125 1 12 3.46875 12 6.5C12 9.5625 9.53125 12 6.5 12Z"
        fill="currentColor"
      />
    </svg>
  );
}
